module.exports = __webpack_public_path__ + "static/img/shiming.df2290d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view10/shiming.png
// module id = IgNu
// module chunks = 1